function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import { GALLERY_CONSTS, utils } from 'pro-gallery-lib';
import { GalleryComponent } from '../galleryComponent';

var ItemHover = /*#__PURE__*/function (_GalleryComponent) {
  _inheritsLoose(ItemHover, _GalleryComponent);

  function ItemHover() {
    return _GalleryComponent.apply(this, arguments) || this;
  }

  var _proto = ItemHover.prototype;

  _proto.getHoverClass = function getHoverClass() {
    var _this$props = this.props,
        styleParams = _this$props.styleParams,
        forceShowHover = _this$props.forceShowHover;
    var hoverClass = ['gallery-item-hover'];
    hoverClass.push('fullscreen-' + (styleParams.fullscreen ? 'enabled' : 'disabled'));

    if (utils.isUndefined(styleParams.itemOpacity)) {
      //if gallery was just added to the page, and it's settings were never opened,
      //the styles of opacity and background were not set (are undefined),
      //so we are using the default background & opacity (is scss under .gallery-item-hover.default)
      hoverClass.push('default');
    }

    if (forceShowHover) {
      //in mobile, when item is hovered (tapped, with all the right configurations), forceShowHover is true
      hoverClass.push('force-hover');
    } else if (utils.isMobile()) {
      hoverClass.push('hide-hover');
    }

    return hoverClass.join(' ');
  };

  _proto.shouldRenderHoverInnerIfExist = function shouldRenderHoverInnerIfExist() {
    var _this$props2 = this.props,
        itemWasHovered = _this$props2.itemWasHovered,
        styleParams = _this$props2.styleParams;
    var hoveringBehaviour = styleParams.hoveringBehaviour,
        overlayAnimation = styleParams.overlayAnimation,
        alwaysShowHover = styleParams.alwaysShowHover;
    var APPEARS = GALLERY_CONSTS.infoBehaviourOnHover.APPEARS;
    var NO_EFFECT = GALLERY_CONSTS.overlayAnimations.NO_EFFECT;

    if (alwaysShowHover) {
      return true;
    }

    if (hoveringBehaviour === APPEARS && overlayAnimation !== NO_EFFECT) {
      //when there is a specific overlayAnimation, to support the animation we render the itemHover before any hover activity (see 'shouldHover()' in itemView).
      //so in this specific case, the itemHover exists right away, but we do'nt want to render yet the hover-inner,
      //the hover-inner will be rendered only after (at) the first hover an on, and not before.
      return itemWasHovered;
    }

    return true;
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        imageDimensions = _this$props3.imageDimensions,
        actions = _this$props3.actions,
        idx = _this$props3.idx,
        renderCustomInfo = _this$props3.renderCustomInfo;
    var hoverClass = this.getHoverClass();
    return /*#__PURE__*/React.createElement("div", {
      className: hoverClass,
      key: 'item-hover-' + idx,
      "data-hook": 'item-hover-' + idx,
      "aria-hidden": true,
      style: imageDimensions && imageDimensions.borderRadius ? {
        borderRadius: imageDimensions.borderRadius
      } : {}
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        height: '100%'
      },
      onTouchStart: actions.handleItemMouseDown,
      onTouchEnd: actions.handleItemMouseUp
    }, this.shouldRenderHoverInnerIfExist() && renderCustomInfo ? /*#__PURE__*/React.createElement("div", {
      className: "gallery-item-hover-inner"
    }, renderCustomInfo()) : null));
  };

  return ItemHover;
}(GalleryComponent);

export { ItemHover as default };